import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GoogleOAuthProvider } from '@react-oauth/google';

import WorkerRoutes from "./Icommunetech/Workers/routes/worker.routes";

import ScrollToTop from "./ScrollToTop";

const clientId = process.env.REACT_APP_AUTH_CLIENT_ID;

function App() {
  return (
    <>
      <GoogleOAuthProvider clientId={clientId}>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/*" element={<WorkerRoutes />} />
          </Routes>
        </Router>
      </GoogleOAuthProvider>
      <ToastContainer />
    </>
  );
}

export default App;
